import type { IconSvgObject } from './types';

const RectangleCircleIcon: IconSvgObject = [
  ["circle", { cx: "14", cy: "12", r: "8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 14V10C2 7.17157 2 5.75736 2.87868 4.87868C3.75736 4 5.17157 4 8 4H14V20H8C5.17157 20 3.75736 20 2.87868 19.1213C2 18.2426 2 16.8284 2 14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default RectangleCircleIcon;
